import { getApp, getApps, initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getRemoteConfig } from 'firebase/remote-config';
import { getAnalytics, isSupported } from 'firebase/analytics';
import {
  REMOTE_CONFIG_DEFAULTS,
  REMOTE_CONFIG_INTERVALS,
  REMOTE_CONFIG_TIMEOUT,
} from '../constants/remoteConfig.constant';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_APIKEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTHDOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECTID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGEBUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGINGSENDERID,
  appId: import.meta.env.VITE_FIREBASE_APPID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENTID,
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
export const firestore = getFirestore(app);
export const firebaseRemoteConfig = getRemoteConfig(app);

export async function getFirebaseAnalytics() {
  const supported = await isSupported();
  return supported ? getAnalytics(app) : null;
}

firebaseRemoteConfig.defaultConfig = REMOTE_CONFIG_DEFAULTS;

const isDevelopment = import.meta.env.VITE_NODE_ENV === 'development';
firebaseRemoteConfig.settings.minimumFetchIntervalMillis = isDevelopment
  ? REMOTE_CONFIG_INTERVALS.DEVELOPMENT
  : REMOTE_CONFIG_INTERVALS.PRODUCTION;

firebaseRemoteConfig.settings.fetchTimeoutMillis = REMOTE_CONFIG_TIMEOUT;
